export default __webpack_public_path__ + "static/media/tk.935191a1.svg";